module.exports = __webpack_public_path__ + "img/Shelter.d19327ad.svg";